import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { EStorageType } from "../data-types/storage.enum";
import { LocalStorageService } from "../services/local-storage.service";

@Injectable()
export class CowingGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (LocalStorageService.instance.get(EStorageType.Token) != null) {
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(["/landing"]);
    return false;
  }
}
